var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header',{scopedSlots:_vm._u([{key:"header-title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("bot.title"))+" ")]},proxy:true}])}),_c('settings-tab',{staticClass:"mb-4",attrs:{"tabs":_vm.tabs,"current-tab":_vm.currentTab},on:{"change":_vm.changeRouteView}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }